<template>
  <b-row class="no-gutters ml-n3">
    <b-col class="col-12 col-md-6 col-lg-4 pl-3">
      <search-input
        v-model="searchInput"
        label="search"
        :placeholder="$t('page.domiUser.searchPlaceholder')"
        @search="search"
      ></search-input>
    </b-col>
    <b-col class="col-12 col-md-6 col-lg-4 pl-3">
      <form-select v-model="filterUserStatus" label="status">
        <b-form-select-option :value="null">
          {{ $t("all") }}
        </b-form-select-option>
        <b-form-select-option
          v-for="(status, index) in domiUserStatusOptions"
          :key="index"
          :value="status"
        >
          {{ $t(status) }}
        </b-form-select-option>
      </form-select>
    </b-col>
  </b-row>
</template>

<script>
import SearchInput from "../Base/BaseSearchInput";
import FormSelect from "../Base/BaseFormSelect";
export default {
  components: {
    SearchInput,
    FormSelect
  },
  data() {
    return {
      searchInput: "",
      domiUserStatusOptions: ["active", "notverified"]
    };
  },
  mounted() {
    this.searchInput = this.filterSearch;
  },
  computed: {
    filterSearch: {
      get() {
        return this.$store.getters["domi/getFilterSearch"];
      },
      set(value) {
        this.$store.commit("domi/SET_FILTER_SEARCH", value);
      }
    },
    filterUserStatus: {
      get() {
        return this.$store.getters["domi/getFilterUserStatus"];
      },
      set(value) {
        this.$store.commit("domi/SET_FILTER_USER_STATUS", value);
        this.retrieveDomiUsers();
      }
    }
  },
  methods: {
    search() {
      this.filterSearch = this.searchInput;
      this.retrieveDomiUsers();
    },
    async retrieveDomiUsers() {
      try {
        this.$store.commit("loader/SET_LOADER", {});
        await this.$store.dispatch("domi/retrieveDomiUsers");
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("loader/RESET");
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
